import { render, staticRenderFns } from "./PostPdfVoLandscape.vue?vue&type=template&id=3afb4e3c&scoped=true&"
import script from "./PostPdfVoLandscape.vue?vue&type=script&lang=js&"
export * from "./PostPdfVoLandscape.vue?vue&type=script&lang=js&"
import style0 from "./PostPdfVoLandscape.vue?vue&type=style&index=0&id=3afb4e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afb4e3c",
  null
  
)

export default component.exports